import { z } from 'zod';
/** POST /api/v1/auth/magic-link/request body. */
export const MagicLinkRequestSchema = z.object({
    email: z.string().email().max(254).toLowerCase(),
});
/** POST /api/v1/auth/magic-link/verify body.
 *  Token is a base64url-encoded 32-byte random string (length 43 chars).
 *  Verify is a POST (not GET) so corporate email-link scanners that
 *  pre-fetch URLs do not burn the single-use token before the human clicks.
 *  See docs/design/00-system-design.md §8.1 for rationale. */
export const MagicLinkVerifyRequestSchema = z.object({
    token: z.string().min(32).max(256),
});
/** Response after a magic-link request is accepted.
 *  Always returns 200 even for unknown emails (no account enumeration). */
export const MagicLinkRequestResponseSchema = z.object({
    status: z.literal('queued'),
    message: z.string(),
});
//# sourceMappingURL=magic-link.schema.js.map